import React from "react";

interface IconIProps {
  size?: string;
}

const DocxIcon = ({ size = "24" }: IconIProps) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M21.6045 2.25001H7.27875C7.1613 2.24971 7.04494 2.2726 6.93634 2.31737C6.82775 2.36213 6.72906 2.4279 6.64594 2.51088C6.56282 2.59387 6.49689 2.69244 6.45194 2.80096C6.40699 2.90948 6.3839 3.0258 6.384 3.14325V7.125L14.6858 9.5625L22.5 7.125V3.14325C22.5001 3.02573 22.477 2.90935 22.432 2.80079C22.387 2.69222 22.321 2.59361 22.2378 2.51061C22.1546 2.42762 22.0558 2.36187 21.9471 2.31715C21.8385 2.27243 21.722 2.24961 21.6045 2.25001Z"
        fill="#41A5EE"
      />
      <path
        d="M22.5 7.125H6.384V12L14.6858 13.4625L22.5 12V7.125Z"
        fill="#2B7CD3"
      />
      <path
        d="M6.384 12V16.875L14.1975 17.85L22.5 16.875V12H6.384Z"
        fill="#185ABD"
      />
      <path
        d="M7.27875 21.75H21.6038C21.7213 21.7505 21.8379 21.7277 21.9466 21.6831C22.0554 21.6384 22.1543 21.5727 22.2375 21.4897C22.3208 21.4067 22.3869 21.308 22.4319 21.1994C22.477 21.0908 22.5001 20.9743 22.5 20.8567V16.875H6.384V20.8567C6.3839 20.9742 6.40699 21.0905 6.45194 21.199C6.49689 21.3076 6.56282 21.4061 6.64594 21.4891C6.72906 21.5721 6.82775 21.6379 6.93634 21.6826C7.04494 21.7274 7.1613 21.7503 7.27875 21.75Z"
        fill="#103F91"
      />
      <path
        opacity="0.1"
        d="M12.3255 6.1499H6.384V18.3374H12.3255C12.5623 18.3362 12.789 18.2418 12.9566 18.0746C13.1242 17.9074 13.2192 17.6809 13.221 17.4442V7.04315C13.2192 6.80641 13.1242 6.57989 12.9566 6.4127C12.789 6.2455 12.5623 6.15108 12.3255 6.1499Z"
        fill="black"
      />
      <path
        opacity="0.2"
        d="M11.8373 6.63745H6.384V18.825H11.8373C12.074 18.8238 12.3008 18.7294 12.4684 18.5622C12.636 18.395 12.731 18.1684 12.7328 17.9317V7.5307C12.731 7.29396 12.636 7.06744 12.4684 6.90024C12.3008 6.73305 12.074 6.63863 11.8373 6.63745Z"
        fill="black"
      />
      <path
        opacity="0.2"
        d="M11.8373 6.63745H6.384V17.85H11.8373C12.074 17.8488 12.3008 17.7544 12.4684 17.5872C12.636 17.42 12.731 17.1934 12.7328 16.9567V7.5307C12.731 7.29396 12.636 7.06744 12.4684 6.90024C12.3008 6.73305 12.074 6.63863 11.8373 6.63745Z"
        fill="black"
      />
      <path
        opacity="0.2"
        d="M11.349 6.63745H6.384V17.85H11.349C11.5858 17.8488 11.8125 17.7544 11.9801 17.5872C12.1477 17.42 12.2427 17.1934 12.2445 16.9567V7.5307C12.2427 7.29396 12.1477 7.06744 11.9801 6.90024C11.8125 6.73305 11.5858 6.63863 11.349 6.63745Z"
        fill="black"
      />
      <path
        d="M2.3955 6.63746H11.349C11.5862 6.63726 11.8137 6.73123 11.9816 6.89873C12.1496 7.06622 12.2441 7.29353 12.2445 7.53071V16.4692C12.2441 16.7064 12.1496 16.9337 11.9816 17.1012C11.8137 17.2687 11.5862 17.3627 11.349 17.3625H2.3955C2.27798 17.3629 2.16154 17.34 2.05286 17.2953C1.94418 17.2506 1.84541 17.1848 1.7622 17.1018C1.679 17.0189 1.613 16.9202 1.56801 16.8117C1.52301 16.7031 1.4999 16.5867 1.5 16.4692V7.53071C1.4999 7.41319 1.52301 7.2968 1.56801 7.18824C1.613 7.07967 1.679 6.98106 1.7622 6.89806C1.84541 6.81507 1.94418 6.74932 2.05286 6.7046C2.16154 6.65988 2.27798 6.63706 2.3955 6.63746Z"
        fill="url(#paint0_linear_2814_6288)"
      />
      <path
        d="M5.175 13.4911C5.1925 13.6291 5.204 13.7493 5.2095 13.8518H5.2305C5.238 13.7543 5.25425 13.6368 5.27925 13.4993C5.31675 13.2931 5.32575 13.2458 5.346 13.1506L6.28725 9.09534H7.50525L8.48025 13.0898C8.53656 13.337 8.57714 13.5875 8.60175 13.8398H8.61825C8.63696 13.5942 8.67077 13.35 8.7195 13.1086L9.49875 9.09009H10.6065L9.2385 14.9011H7.94325L7.0155 11.0566C6.9885 10.9456 6.958 10.8011 6.924 10.6231C6.89 10.4451 6.869 10.3151 6.861 10.2331H6.84525C6.83475 10.3276 6.81375 10.4678 6.78225 10.6538C6.75075 10.8398 6.72575 10.9778 6.70725 11.0678L5.835 14.9033H4.518L3.1425 9.09534H4.2675L5.11575 13.1588C5.14048 13.2686 5.16025 13.3795 5.175 13.4911Z"
        fill="white"
      />
      <defs>
        <linearGradient
          id="paint0_linear_2814_6288"
          x1="3.3705"
          y1="5.93546"
          x2="10.374"
          y2="18.0645"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#2368C4" />
          <stop offset="0.5" stopColor="#1A5DBE" />
          <stop offset="1" stopColor="#1146AC" />
        </linearGradient>
      </defs>
    </svg>
  );
};
export default DocxIcon;
